import {
  CancelBookingCancellerEnum,
  InvoiceStatus
} from '@link/supplier/services/const';

export default {
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '与销售对象的合同状态',
      activitiesManagement: '商品管理',
      activities: '商品列表',
      allotmentSettings: '设置库存',
      backendSettings: '后端库存设置',
      backendCalendar: '日历',
      settings: '设置',
      changePassword: '更改密码',
      suppliers: '供应商管理',
      suppliersDetail: '公司信息',
      suppliersAccount: '账户管理',
      info: '基本信息',
      detail: '详细信息',
      agent: '价格分组设置',
      i18n: '多语言设置',
      planInfo: '方案－{{title}}',
      bookingInfoSettings: '预订信息设置',
      price: '单位/价格',
      addPlan: '新增方案',
      editMemo: '编辑备注',
      editLog: '编辑历史记录',
      adminSetting: '管理员设置',
      adminPlanInfo: '方案－{{title}} 设置',
      adminActivity: '设置商品',
      allotmentSetting: '营业日·普通库存设置',
      allotmentSegmentId: '新增开始时间ID',
      allotmentException: '例外开始时间设置',
      allotmentCalendar: '日历编辑',
      allotmentOtaGroup: '旅行社库存分组设置',
      allotmentBackend: '后端设置',
      booking: '预订',
      unprocessedList: '未处理列表',
      finance: '付款管理',
      bulkOrder: '批量预订',
      dataExport: '数据导出'
    }
  },
  views: {
    dataExport: {
      period: '期间',
      dataExport: '数据导出',
      bookingData: '预订数据',
      dateMode: '日期模式',
      byBookingDate: '按预订日',
      byParticipationDate: '按参加日',
      outputMode: '导出形式',
      byBookings: '按预订',
      byTravelers: '按旅客',
      status: '状态',
      download: '下载文件',
      today: '今天',
      yesterday: '昨天',
      oneWeek: '一周',
      thisMonth: '本月',
      lastMonth: '上月'
    },
    bulkBookingDetail: {
      history: '操作内容',
      action: '操作',
      operator: '操作者',
      date: '日期',
      message: '消息',
      notifyConfirmed: '汇款审批',
      paymentDate: '汇款日',
      paymentConfirmed: '已批准汇款',
      infoSentToSupplier: '信息已发送至旅行社'
    },
    dashboard: {
      title: '数据看板'
    },
    activities: {
      templateSource: '商品',
      heading: '商品列表',
      status: '状态',
      title: '商品名称',
      inputSupplierTitle: '请输入商品名称',
      addActivity: '登录商品',
      edit: '编辑',
      confirmed: '商品设置完成，可以公开了。',
      name: '商品名称',
      list: '商品列表',
      addNewActivity: '登录新商品',
      add: '登录',
      selectSupplier: '请选择供应商',
      copyTitle: '复制商品',
      selectSupplierLabel: '供应商选择',
      copy: '复制',
      copyModalTitle: '复制-{{text}}',
      export: '下载',
      isBulkOrder: '批量预订'
    },
    backendSettings: {
      newTitle: '设置新的后端库存',
      management: '库存登记',
      poolId: '管理 ID',
      supplierId: '供应商名',
      name: '管理用名称',
      confirm: '确定',
      state: '状态',
      status: '状态',
      lastExecution: '最后更新',
      nextExecution: '下次更新',
      jobStatus: {
        success: '成功',
        failed: '失败'
      }
    },
    activity: {
      mergePlanError: '若商品已存在方案，禁止进行导入',
      importError: '文件格式或内容存在问题',
      import: '导入',
      title: '商品',
      log: {
        logHistory: '商品编辑历史',
        priceHistory: '价格分组编辑历史',
        chooseLog: '选择历史记录',
        chooseItemLabel: '方案 {{index}} 编辑历史',
        html: 'HTML日志',
        by: '经过'
      },
      memo: {
        title: '编辑备注',
        tips: '编辑备注仅用于商品编辑记录，不会显示在旅行社或直销网站上。',
        successUpdated: '备注已保存'
      },
      tag: {
        title: '编辑标签',
        tips: '编辑标签仅用于商品编辑记录，不会显示在旅行社或直销网站上。'
      },
      paymentCollector: '收款方',
      productDescription: '商品说明',
      priceSetting: '支付货币设置',
      autoPublic: '自动发布设置',
      autoPublicGroup: '目标分组选择',
      imageSetting: '图片设置',
      participantNotice: '参加前后注意事项（包含内容等）',
      agentGroupName: '价格分组名称',
      agentSaved: '已保存旅行社',
      agentSetting: '设置价格分组',
      addAgentGroup: '新增价格分组',
      agentTips:
        '※价格分组与每家旅行社的价格设置相关联，因此一家旅行社不能加入多个分组。',
      comment: '备注',
      publishedApplied: '已提交发布申请',
      rejectApplied: '已驳回',
      approved: '已批准',
      published: '已公开',
      publish: '公开',
      publishToNeoOnly: '仅公开至NEO',
      publishToNextOnly: '仅公开至NEXT（现行系统）',
      reject: '驳回',
      approve: '发布审批',
      submit: '公开申请',
      save: '保存',
      preview: '预览',
      productPreview: '商品预览',
      voucherPreview: 'Voucher预览',
      applyForPublish: '申请商品发布',
      productConfirmationMessage:
        '请确认已注册的商品内容与方案后再进行商品发布。',
      confirmPermission: '没有权限',
      confirmReject: '驳回审批',
      confirmApprovalOfProduct: '审批商品发布',
      productContentConfirmed: '已确认商品内容',
      confirmForPublishingProducts: '商品发布确认',
      productPublishedConfirmed: '已批准商品发布',
      productSaved: '商品已保存',
      languageSetting: '多语言设置',
      languageSelection: '语言选择',
      productTitle: '商品名称（凭证显示名称）',
      origin: '出发地',
      destination: '目的地',
      checkinPoints: '集合地点',
      checkoutPoints: '解散地点',
      pickupLocation: '接送地点',
      dropoffLocations: '送达地点',
      cancellationPolicy: '取消政策',
      faqSetting: 'FAQ设置',
      chosenLanguage: '翻译语言',
      timeZone: '国家・地区（时区）',
      category: '分类',
      useQrCode: '二维码使用设置',
      qrcodeType: '二维码类型',
      qrcodeDisplayLocations: '二维码展示位置',
      voucherSetting: '凭证设置',
      voucherVersion: '凭证版本',
      appointmentSetting: '预订设置',
      appointmentNotification: '预订通知',
      useEticketItems: '电子票券使用项目',
      qrcodeTemplate: '二维码模板',
      qrcodeHeader: '二维码页眉',
      qrcodeFooter: '二维码页脚',
      qrcodeGenerator: '二维码生成器',
      redemptionUrlTemplate: '兑换URL模板',
      adminSettingSaved: '已保存管理员设置',
      allotmentSettingSaved: '已保存方案设置',
      planSelection: '方案选择',
      planId: '方案ID',
      systemCharge: '系统费用',
      productInfo: '商品信息',
      supplierId: '供应商ID',
      supplierName: '供应商名称',
      name: '商品名称',
      editMemo: '编辑备注',
      editTag: '编辑标签',
      publishActivityConfirm: '是否发布该商品？',
      publishActivitySuccess:
        '※商品公开后，已加入价格设置的旅行社账号将可查看商品信息。',
      inPublish: '发布中',
      isActivityPublished: '商品已发布',
      isActivityPublishedFailed: '商品发布失败',
      contactUs: '给您带来的不便，我们深表歉意，请联系负责人协助您处理。',
      leaveCurrentPage: '离开此页面',
      continueEditing: '继续编辑',
      salesStatus: '商品显示',
      hideFromSearch: '商品列表显示',
      salesStatusNotes: '*若变更商品显示状态，需重新进行发布，敬请注意。',
      hideFromSearchNotes:
        '*若关闭商品列表显示，将不会显示于搜索结果及商品列表页面，敬请注意。',
      qrCodeTips: '※ “按人数生成二维码”或“检票使用”设置请联系我司负责人。'
    },
    allotmentSettings: {
      heading: '营业日·普通库存设置',
      title: '库存设置',
      new: '登记库存',
      poolId: '管理 ID',
      supplierId: '供应商名称',
      name: '管理用库存名称',
      inputAllotmentName: '请输入管理用库存名称',
      leaveCurrentPage: '离开此页面',
      continueEditing: '继续编辑',
      edit: {
        name: '库存',
        createTitle: '新增库存',
        copyTitle: '复制库存'
      },
      form: {
        id: '库存ID',
        name: '管理用库存名称',
        freesale: '无库存限制',
        copyCalendarEdits: '复制日历编辑',
        add: '新增普通库存'
      },
      exception: {
        name: '特定日期开始时间设置',
        default: '普通库存',
        allowedDefault: '可使用',
        disallowedDefault: '不可使用',
        defaultApplicable: '（已应用普通库存设置：{{applicable}}）',
        applicable: '适用',
        notApplicable: '不适用'
      },
      segmentId: {
        name: '开始时间ID',
        addPrompt: '新增开始时间ID',
        refTime: '参考时间',
        startTimeIdRequired: '请输入开始时间ID',
        startTimeRequired: '请输入开始时间'
      },
      otaGroup: {
        name: '旅行社库存分组设置',
        groupName: '旅行社库存分组名称',
        addPrompt: '新增旅行社库存设置',
        addOta: '新增旅行社',
        deleteOta: '删除旅行社'
      },
      backendBundle: {
        backendOption: '后端',
        bundleOption: '套装',
        backendId: '后端库存 ID',
        bundleChildAllotmentPoolId: '关联子商品库存ID',
        parentStartTimeId: '开始时间库存ID',
        refTime: '参考时间',
        childStartTimeId: '子商品开始时间库存ID',
        addPrompt: '新增关联子商品ID',
        label: '选择后端',
        bundleStartTimeSetting: '开始时间ID设置',
        segmentTime: '开始时间ID',
        childSegmentTimeId: '子商品开始时间ID',
        backendAllotment: '设置后端库存',
        bundleAddPrompt: '新增Bundle库存设置',
        bundleGroupHeaderText: '关联子商品ID'
      }
    },
    agentGroup: {
      addAgent: '新增旅行社',
      deleteAgent: '删除旅行社'
    },
    plan: {
      title: '方案',
      saveConfirm: '已保存方案',
      name: '方案名',
      planPublish: '方案显示名称',
      bookingRule: '预订设置',
      voucherExpiration: '凭证有效期限',
      expirationVisibilitySetting: '隐藏凭证有效期限',
      visibilitySetting: {
        hideFromVoucher: '凭证上不显示',
        hideFromActivityDetails: '网页上不显示（商品内容）',
        hideFromBookingDetails: '网页上不显示（预订详情）'
      },
      checkinPoint: '集合地点',
      checkoutPoint: '解散地点',
      pickupLocation: '接送地点',
      dropoffLocation: '送达地点',
      unitSetting: '设置单位',
      priceSetting: '设置价格',
      bookingAgentRequiredInfo: '代表者信息－每笔预订（必填）',
      bookingAgentRecommendedInfo: '代表者信息－每笔预订（选填）',
      bookingOtherRequiredInfo: '其他信息－每笔预订（必填）',
      bookingOtherRecommendedInfo: '其他信息－每笔预订（选填）',
      participantRequiredInfo: '使用者信息－每位参加者（必填）',
      participantRecommendedInfo: '使用者信息－每位参加者（选填）',
      customBookingInfo: '自定义预订信息',
      settingUnable: '结束日期不能早于开始日期设置',
      description: '方案说明',
      imageSetting: '设置图片',
      availablePeriod: '公开期间',
      reservationRestrict: '预订数量限制',
      pieces: '张',
      min: '最少',
      max: '最多',
      tilde: '~',
      checklistLabel: '参加前·参加时注意事项（包含内容等）',
      startTime: '开始时间',
      setSchedule: '行程设置',
      editConfirm: '编辑确认',
      leave: '离开此页面',
      continueEditing: '继续编辑',
      code: {
        id: '方案ID',
        coupon: '隐藏Bundle子商品凭证',
        backendId: '库存设置ID',
        backendIdLabel: '请选择库存设置',
        metadata: 'Metadata',
        metadataLabel: '输入的内容请与研发确认',
        goToSetting: '如未设置，请从<0>此处</0>进行设置',
        backend: '后端信息',
        backendLabel: '请选择要关联的后端',
        productCode: '商品代码',
        productCodeLabel: '请填写商品代码',
        unit: '单位设置',
        unitType: '单位类型',
        unitRange: '单位范围',
        unitCode: '单位代码',
        startTimeTitle: '设置开始时间',
        startTime: '开始时间',
        startTimeCode: '开始时间代码',
        codeLabel: '请输入代码',
        linkToAllotment: '链接至库存设置'
      },
      planPublishNotes: '*若变更方案显示状态，需重新进行商品发布，敬请注意。',
      duplicatePlan: '复制方案',
      ruleDeadlineDayNotes: '※若预约期限输入“0”，将以【当日】起算并包含当日。',
      voucherExpirationNotes:
        '※若有效期限输入“1”，将以【当日】起算并包含当日；输入“0”时将立即失效，请注意。'
    },
    bookingTodos: {
      title: '未处理列表',
      count: '条',
      within24Hours: '24小时内',
      within5Days: '5天内',
      within7Days: '7天内',
      over7Days: '7日以上',
      purchasedDate: '付款申请日',
      productPlan: '商品/方案',
      bookerName: '预订者姓名',
      deadline: '截止时间',
      timeRemaining: '距离截止剩余时间',
      timeRemainingFormat: '{{hours}}小时{{minutes}}分{{seconds}}秒'
    },
    bookingDetail: {
      requestPanelTitle: '待确认订单处理回复',
      applicationDate: '申请日期时间',
      deadlineLabel: '截止时间',
      accept: '批准',
      deny: '不可受理',
      rejects: '拒绝',
      denyReasonPlaceholder: '请填写拒绝理由。',
      actionTitle: '您已{{action}}此预订请求'
    },
    bookingCancel: {
      form: '取消表单',
      canceller: '取消者',
      reason: '原因',
      comment: '备注',
      cancellationFee: '取消费用',
      time: '当前日期时间',
      money: '金额',
      refundAllSystemFee: '全额退还系统费用',
      discount: 'X',
      percentFormula: '% =',
      pleaseSetCancelFee: '请设置取消费用'
    },
    financeHistory: {
      title: '付款记录',
      dataAggregation: '数据汇总',
      aggregationUnit: '汇总单位',
      targetPeriod: '时间范围',
      monthly: '月度',
      weekly: '周次',
      confirmed: '已确定',
      canceledRefund: '取消退款',
      differenceAdjusted: '差额已调整',
      totalAmount: '合计金额',
      cancellationFee: '（含取消费用）',
      serviceFee: '系统费用',
      totalPaymentAmount: '付款金额合计',
      price: '({{currency}})',
      salesPrice: '销售价格',
      wholesalePrice: '批发价格',
      commission: '手续费',
      transactionSearch: '预订搜索',
      applicationDate: '申请日',
      participationDate: '参加日',
      transactionStatus: '预订状态',
      keyword: '关键词',
      activity: '商品',
      plan: '方案',
      supplier: '供应商',
      reservationNumber: '预订编号',
      currency: '货币'
    },
    financeTransactions: {
      title: '结算报表',
      transactionStatus: '结算状态',
      keyword: 'ID搜索',
      difference: '差异调整',
      dueDate: '账单发行日',
      invoiceNumber: '账单 ID',
      date: '请款期间',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '货币单位',
      amount: '付款金额合计',
      adjustedAmount: '调整金额',
      finalAmount: '最终合计金额',
      showjust: '显示',
      change: '付款完成',
      invoice: '账单明细',
      jaInvoice: '日文账单',
      jaInvoiceDetails: '明细书(日文)',
      enInvoice: '英文账单',
      enInvoiceDetails: '明细书(英文)',
      attachment: '附件',
      changeTitle: '是否已完成付款？',
      changeMessage: '交易状态将变更为“付款完成”'
    }
  },
  common: {
    activityId: '模板ID',
    search: '搜索',
    leaveCurrentPageConfirm: '{{name}}仍在编辑中',
    successCreatedMsg: '{{name}}新增成功',
    errorCreatedMsg: '{{name}}新增失败',
    successDeletedMsg: '{{name}}删除成功',
    errorDeletedMsg: '{{name}}删除失败',
    successUpdatedMsg: '{{name}}更新成功',
    errorUpdatedMsg: '{{name}}更新失败',
    sharedAllotment: '共享库存',
    colon: '：'
  },
  const: {
    cancelBookingCanceller: {
      [CancelBookingCancellerEnum.Supplier]: '供应商',
      [CancelBookingCancellerEnum.SupplierForTraveler]: '客人'
    },
    templateStatus: {
      DRAFT: '草稿',
      REVIEWING: '发布申请中',
      APPROVED: '已确认发布',
      PUBLISHED: '已公开（仅NEXT）',
      NEO_PUBLISHED: '已公开（仅NEO）',
      BOTH_PUBLISHED: '已公开（NEO・NEXT）'
    },
    jobState: {
      ENABLED: '成功',
      PAUSED: '停止',
      DISABLED: '无效',
      UPDATE_FAILED: '更新失败',
      ERROR: '错误'
    },
    universalType: {
      TRUE: '各方案共用',
      FALSE: '各方案不同'
    },
    voucherType: {
      NONE: '不需要',
      COLLECTIVE: '每笔预订一个二维码',
      INDIVIDUAL: '每人一个二维码'
    },
    qrcodeType: {
      QRCODE: '二维码',
      TEXT: '文本',
      URL: 'URL',
      BARCODE_128: '条形码_128',
      BARCODE_93: '条形码_93',
      BARCODE_39: '条形码_39',
      BARCODE_25: '条形码_25'
    },
    qrcodeDisplayLocation: {
      QR_CODE_DISPLAY_LOCATION_VOUCHER: '凭证',
      QR_CODE_DISPLAY_LOCATION_ETICKET_PORTAL_SITE: '电子票券显示页面'
    },
    voucherMedium: {
      ELECTRONIC: '无需打印（出示页面）',
      PAPER: '需要打印'
    },
    voucherVersion: {
      VOUCHER_VERSION_V1: 'V1',
      VOUCHER_VERSION_V2: 'V2'
    },
    formatType: {
      BEFORE_ACTIVITY_FORWARD_FIXED_CLOCK:
        '在使用／参加日前{D}天当地时间{HH:MM}之后取消，将收取预订总金额的{N}作为取消费用。',
      BEFORE_ACTIVITY_FORWARD_DURATION:
        '在使用／参加时间前{T}小时起取消，将收取预订总金额的{N}作为取消费用。',
      AFTER_BOOKING_FORWARD_DURATION:
        '在预订确认后{T}小时起取消，将收取预订总金额的{N}作为取消费用。',
      AFTER_BOOKING_FORWARD_FIXED_CLOCK:
        '以预订确认日为第0天，自第{D}天当地时间{HH:MM}起取消，将收取预订总金额的{N}作为取消费用。',
      BEFORE_ACTIVITY_BACKWARD_FIXED_CLOCK:
        '在使用／参加日前{D}天当地时间{HH:MM}前取消，将收取预订总金额的{N}作为取消费用。',
      BEFORE_ACTIVITY_BACKWARD_DURATION:
        '在使用／参加时间前{T}小时前取消，将收取预订总金额的{N}作为取消费用。',
      AFTER_BOOKING_BACKWARD_DURATION:
        '在预订确认后{T}小时内取消，将收取预订总金额的{N}作为取消费用。',
      AFTER_BOOKING_BACKWARD_FIXED_CLOCK:
        '以预订确认日为第0天，至第{D}天当地时间{HH:MM}前取消，将收取预订总金额的{N}作为取消费用。'
    },
    cancellationFeeType: {
      PERCENTAGE: '百分比',
      ADVANCED_PERCENTAGE: '高级百分比设置',
      FIXED: '固定费用',
      NOT_CANCELLABLE: '不可取消'
    },
    basePrice: {
      GROSS: '销售价格',
      NET: '批发价格',
      SUPPLIER_NET: '供应商批发价格'
    },
    confirmationType: {
      FREE_SALE: '指定参加日（无库存限制）',
      FREE_SALE_OPEN_DATE: '不需指定参加日（无库存限制）',
      INVENTORY: '指定参加日（即时确认）',
      REQUEST: '指定参加日（需待确认）'
    },
    datePeriodUnit: {
      DAY: '以日计算',
      MONTH: '以月计算'
    },
    datePeriod: {
      DAY: '天',
      MONTH: '个月',
      tilde: '~'
    },
    collectingType: {
      PER_PARTICIPANT: '每位参加者',
      PER_BOOKING: '每笔预订'
    },
    collectingTiming: {
      ON_BOOKING: '预订时必填',
      BEFORE_ACTIVITY: '参加日前必填',
      OPTIONAL: '选填'
    },
    formType: {
      DATE_ONLY_PAST: '日期（仅限过去）',
      DATE_ONLY_FUTURE: '日期（仅限未来）',
      TIME: '时间',
      YES_NO: '是/否',
      DROPDOWN: '下拉菜单',
      RADIO: '单选按钮',
      CHECK: '复选框',
      TEXT: '文本',
      TEXT_ALPHANUMERIC: '文本（字母数字）',
      TEXT_PHONE: '电话号码',
      TEXTAREA: '文本区域'
    },
    voucherExpirationType: {
      FROM_PURCHASE_DATE: '自购买之日起',
      FROM_ACTIVITY_DATE: '自参加日起',
      FIXED_DATE: '固定日期',
      RELATIVE_FIXED_DATE: '相对日期'
    },
    unit: {
      AGE_ADULT_AND_CHILD: '成人・儿童通用（{n}-{m}）岁',
      AGE_ADULT: '成人（{n}-{m}）岁',
      AGE_YOUTH: '青少年（{n}-{m}）岁',
      AGE_CHILD: '儿童（{n}-{m}）岁',
      AGE_SENIOR: '老年人（{n}-{m}）岁',
      AGE_INFANT: '幼儿（{n}-{m}）岁',
      AGE_STUDENT: '学生（{n}-{m}）岁',
      AGE_HIGH_SCHOOL: '高中生（{n}-{m}）岁',
      AGE_INTERMEDIATE_SCHOOL: '初中生（{n}-{m}）岁',
      AGE_ELEMENTALY_SCHOOL: '小学生（{n}-{m}）岁',
      AGE_COLLEGE: '大学生（{n}-{m}）岁',
      AGE_GRADUATE: '研究生（{n}-{m}）岁',
      AGE_DISABLED_ADULT: '残障人士－成人（{n}-{m}）岁',
      AGE_DISABLED_YOUTH: '残障人士－青少年（{n}-{m}）岁',
      AGE_DISABLED_CHILD: '残障人士－儿童（{n}-{m}）岁',
      AGE_SUPPORTER_ADULT: '陪同者（成人）',
      AGE_SUPPORTER_CHILD: '陪同者（儿童）',
      MINUTES_VEHICLES: '{n} 分钟',
      HOURS_VEHICLES: '{n} 小时',
      DAYS_VEHICLES: '{n} 天',
      WEEKS_VEHICLES: '{n} 周',
      NIGHTS_VEHICLES: '{n} 晚',
      CHARTER_VAR: '每台（{n}-{m}）人',
      GROUP_VAR: '每组（{n}-{m}）人',
      ROOM_VAR: '每间（{n}-{m}）人',
      BOAT_VAR: '每艘（{n}-{m}）人',
      PET: '宠物',
      PET_CAT: '猫',
      PET_DOG: '狗',
      PET_DOG_S: '小型犬',
      PET_DOG_M: '中型犬',
      PET_DOG_L: '大型犬',
      PET_DOG_XL: '超大型犬',
      PET_OTHER: '其他宠物',
      AGE_ADULT_AND_CHILD_2: '一般',
      AGE_CHILD_2: '儿童',
      DRINK_STANDARD_SET: 'THE ROOF SEAT & STANDARD SET',
      DRINK_CHAMPAGNE_SET: 'THE ROOF SEAT & CHAMPAGNE SET',
      QUANTITY: '1个'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '待入账',
      [InvoiceStatus.InvoiceStatusConfirmed]: '入账完成',
      [InvoiceStatus.InvoiceStatusPaid]: '入账确认中',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    activityTags: {
      NON_CANCELLABLE: '不可取消',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '兑换前可免费取消',
      ADVANCE_CANCELLATION_POLICY: '特殊取消政策',
      INSTANT_BOOK: '立即预订',
      NON_QR_CODE: '人工验证凭证',
      QR_CODE: 'QR凭证',
      ETICKET: '电子验票票券（需手机）'
    }
  },
  lang: {
    en: '英文',
    ja: '日文',
    zh: '中文（简体）',
    zt: '中文（繁体）',
    ko: '韩文'
  },
  component: {
    location: {
      title: '{{label}}名称',
      address: '地址',
      placeId: '地点 ID',
      latlong: '纬度和经度',
      select: '{{label}}选择',
      errMsg: '未找到匹配结果，请重新确认输入内容，或从地图直接选择。'
    },
    checklist: {
      notice: '注意事项 {{index}}',
      selectNoticePrompt: '请选择参加前·参加时注意事项',
      uploadPDF: 'PDF上传',
      uploadImage: '图片上传',
      googleMapSetting: 'Google 地图设置'
    },
    cancel: {
      notCancellable: '预订完成后不接受取消或更改。',
      freeCancellable: '兑换前可免费取消；兑换后不接受任何退款。',
      flex: '设置高级取消政策',
      preview: '预览',
      cancelPreview: '取消政策预览',
      info: '自定义描述',
      timeSetting: '取消时间设置',
      day: '日期 {D}',
      timeFormat: '时间{HH:MM}',
      time: '时间 {T}',
      feeSetting: '取消费用设置',
      feeSettingPrompt: '请选择取消费用设置',
      cancelPolicyPrompt: '请选择取消政策',
      priceReferenceSale: '价格基准：销售价格',
      priceReference: '价格基准：',
      fromClient: '由旅客支付（%）',
      fromAgent: '由旅行社支付（%）',
      toSupplier: '支付给供应商（%）',
      paymentCancelFee: '取消费用支付',
      fromClientToAgent: '由旅客支付给旅行社',
      fromAgentToLinktivity: '由旅行社支付给LINKTIVITY',
      fromLinktivityToSupplier: '由LINKTIVITY支付给供应商'
    },
    rule: {
      type: '预订类型',
      possibleInterval: '可预订最大期',
      interval: '预订截止日期',
      daysBefore: '天前',
      timeBefore: '点为止'
    },
    faq: {
      question: '问题',
      answer: '回答',
      faqTitle: '项目 {{index}}'
    },
    voucher: {
      incrementDate: '年度递增基准日'
    },
    startTime: {
      id: 'ID',
      name: '开始时间',
      title: '标题',
      poolId: '开始时间ID'
    },
    itinerary: {
      title: '标题',
      detailedSchedule: '行程详情'
    },
    additional: {
      id: '预订信息ID',
      title: '预订信息标题',
      info: '预订信息说明',
      setting: '预订信息设置方式',
      deadline: '回复截止时间',
      answerType: '回复形式',
      selectItems: '选择项目',
      selectPrompt: '请选择'
    },
    price: {
      info: '价格 {{index}}',
      reservableInterval: '可预订期间',
      startTime: '开始时间',
      endTime: '结束时间',
      unitType: '单位类型',
      unitPrice: '销售单价',
      soldPrice: '销售价格',
      agentPrice: '批发价格',
      comission: '手续费',
      price: '价格',
      accuracy: '精度',
      rate: '汇率',
      comissionRate: '手续费率（显示用）',
      comissionRateTips: '在明细或报表等显示费率时，将显示此处设置的费率',
      auto: '费率精度设置',
      applicableSetting: '适用期间设置',
      applicableInterval: '适用期间',
      applicableDates: '适用星期',
      otherApplicableDates: '其他适用日期',
      unitRange: '单位范围',
      standardPrice: '标准价格',
      numberIncluded: '包含在名额内',
      soloPurchase: '可单独购买'
    },
    backendForm: {
      cloudSchedulerJob: '同步ID',
      state: '状态',
      status: '状态',
      lastExecution: '最后更新',
      nextExecution: '下次更新',
      selectSupplier: '供应商选择',
      name: '管理名称',
      backendPoolId: '后端库存管理ID',
      backend: '后端信息',
      selectBackendPlaceholder: '请选择要关联的后端',
      supplierPoolId: '供应商 Pool ID',
      scheduleTimezone: '更新时间区',
      schedule: '更新计划',
      scheduleNote: '※填写方式请参考此处'
    },
    dateSetting: {
      titlePlaceholder: '请输入库存管理名称',
      name: '设置普通库存',
      interval: '适用期间（星期）',
      exactDates: '特定日期',
      commonAllotment: '库存设置',
      add: '新增普通库存模板',
      common: '共用',
      freesale: '无库存限制',
      createTitle: '设置库存模板',
      modal: {
        interval: '适用期间',
        dates: '适用星期',
        otaAllotments: '旅行社库存设置'
      }
    },
    editAllotment: {
      type: '类型',
      amountReserved: '预订数量',
      amountEdited: '库存数量',
      amountRemains: '剩余库存',
      shared: '共享库存'
    },
    calendar: {
      groupRule: '库存显示',
      week: '周',
      month: '月',
      showMore: '详情',
      amountReserved: '实际预订数',
      amountLimit: '最大预订数',
      edited: '已在日历编辑中设置',
      notice: {
        title: '请谨慎在当前页面直接修改库存数。',
        orderLabel: '常用配置顺序：',
        orderValue: '【营业日·普通库存设置】→【例外开始时间设置】',
        tempLabel: '临时调整/紧急关闭：',
        tempValue: '可以使用【日历编辑】直接修改。',
        priorityLabel: '优先级规则：',
        priorityValue:
          '【日历编辑】（最高）→【例外开始时间设置】（中）→【营业日·普通库存设置】（基础）',
        remark:
          '注：在【日历编辑】中设置库存后，该时段的常规及例外设置将自动失效，系统仅以【日历编辑】的实际数值为准。'
      }
    },
    segmentId: {
      name: '开始时间ID',
      addPrompt: '新增开始时间ID',
      refTime: '参考时间',
      startTimeIdRequired: '请输入开始时间ID',
      startTimeRequired: '请输入开始时间'
    }
  }
};
